






























import { Component } from "vue-property-decorator";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { required, tamCampo, validSlug } from "@/shared/validators";
import { Usuario, UsuariosService } from "@/services/usuarios.service";
import Formulario from "./components/Formulario.vue"

@Component({
  components: {
    Confirm,
    Formulario,
  },
})
export default class AlterarUsuario extends mixins(GlobalMixin) {
  usuario: Usuario = {
    idUsuario: -1,
    nome: "",
    slug: "",
    email: "",
    ativo: true,
    roles: [],
  };

  loading = false;

  rules = {
    nome: [required()],
    slug: [required(), validSlug()],
    email: [required()],
    senha: [required()],
    roles: [required(), tamCampo(1, "Selecione pelo menos 1 role")],
  };

  async mounted() {
    const idUsuario = Number(this.$route.params.id);

    if (!idUsuario || isNaN(idUsuario)) {
      return;
    }

    this.loading = true;
    this.usuario = await UsuariosService.Obter(idUsuario).finally(
      () => (this.loading = false),
    );
  }

  salvarUsuario() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();
      UsuariosService.Alterar(this.usuario)
        .then(this.voltar)
        .finally(this.stopLoader);
    }
  }

  voltar() {
    this.$router.push({
      name: "usuarios",
    });
  }
}
